import React, { useContext } from "react";
import './TransactionTable.css'
import { translate } from "utils/Translate";
import { AppContext } from "contexts/AppContext";
import { priceConvertor } from "utils/general";
import { IconButton, Tooltip } from "@mui/material";
import { Info } from "@mui/icons-material";

const TransactionTable = ({ transactions, canSendBudgetPoints }) => {
  const { langCode, brandData } = useContext(AppContext)

  const pointsSectionLabels = brandData.features?.upgraderClubConfigurableLabels && brandData.features.upgraderClubConfigurableLabels[langCode]?.profilePageLabels?.pointsSectionLabels
    ? brandData.features.upgraderClubConfigurableLabels[langCode].profilePageLabels.pointsSectionLabels : null;

  const starkInfoText = `Det beløb, du ser i kolonnen 'Point', er det antal point, du oprindeligt optjente. Det beløb, du ser i kolonnen 'Ikke brugte point', viser, hvor mange af de oprindelige point du stadig har tilbage.
 
                        Derfor vil 'Ikke brugte point' være det samme som eller lavere end 'Point'. Det skyldes, at du godt kan have brugt nogle af dine optjente point i mellemtiden.
 
  Det er også værd at bemærke, at det afgørende for, om dine point udløber på den dato, der står i kolonnen 'Udløber', ikke er værdien i 'Point'-kolonnen, men derimod den i 'Ikke brugte point'.
  
  Hvis der f.eks. står 100 i 'Point', men 0 i 'Ikke brugte point', betyder det, at de oprindeligt optjente 100 point er blevet brugt. Du har dermed ingen point, der udløber på den dato, der står i 'Udløber'.`

  const isWalletExpiryExpiryEnabled = !!brandData?.features?.enableWalletExpiry

  return (
    <>
      {brandData.BrandID === 87
        ?
          <div className="transaction-table">
            <div className="table-head">
              <div className="th tcol-xsmall"></div>
              <div className="th tcol-1">{pointsSectionLabels?.columnTwoLabel ? pointsSectionLabels.columnTwoLabel : 'Point'}</div>
              <div className="th tcol-2">
                Ikke brugte point
                <Tooltip title={starkInfoText}>
                  <IconButton>
                    <Info />
                  </IconButton>
                </Tooltip>
              </div>
              <div className="th tcol-2">
                Dato optjent / brugt
              </div>
              <div className="th tcol-1">Tilgængelig</div>
              <div className="th tcol-2">Udløber</div>
              <div className="th tcol-3">Point type</div>
              <div className="th tcol-scroll"></div>
              {/* <div className="th tcol-2 ">Note</div> */}
            </div>
            <div className="table-body" style={{overflowY: 'scroll'}}>
              {transactions.map((transaction, idx) => (
                <div className="tr" key={idx}>
                  <div className="td tcol-xsmall"></div>
                  <div className="td tcol-1">{priceConvertor(brandData,transaction.walletAmountPoints, ' ')}</div>
                  <div className="td tcol-2">{transaction.remainingPoints}</div>
                  <div className="td tcol-2">{transaction.date}</div>
                  <div className="td tcol-1">{transaction.validFrom}</div>
                  <div className="td tcol-2">{transaction.expirationDate}</div>
                  <div className="td tcol-3">{transaction.type}</div>
                  {/* <div className="td tcol-2 ">{transaction.walletNote}</div> */}
                </div>
              ))}
            </div>
          </div>
        : canSendBudgetPoints
          ?
            <div className="transaction-table">
              <div className="table-head">
                <div className="th tcol-xsmall"></div>
                <div className="th tcol-4">Note</div>
                <div className="th tcol-1">Point</div>
                {brandData.BrandID !== 87 && (
                  <div className="th tcol-1">Sum</div>
                )}
                <div className="th tcol-2">{translate('_DATE_', 'Dato')}</div>
                <div className="th tcol-2">{translate('_NAME_', 'Navn')}</div>
                <div className="th tcol-2">Email</div>
                <div className="th tcol-1">UID</div>
              </div>
              <div className="table-body">
                {transactions.map((transaction, idx) => (
                  <div className="tr" key={idx}>
                    <div className="td tcol-xsmall"></div>
                    <div className="td tcol-4">{transaction.walletNote}</div>
                    <div className="td tcol-1">{priceConvertor(brandData,transaction.walletAmountPoints, ' ')}</div>
                    {brandData.BrandID !== 87 && (
                        <div className="td tcol-1">{priceConvertor(brandData,transaction.sum, ' ')}</div>
                    )}
                    <div className="td tcol-2">{transaction.date}</div>
                    <div className="td tcol-2">{transaction.Navn}</div>
                    <div className="td tcol-2">{transaction.Email}</div>
                    <div className="td tcol-1">{transaction.UID}</div>
                  </div>
                ))}
              </div>
            </div>
          :
            <div className="transaction-table">
              <div className="table-head">
                <div className="th tcol-xsmall"></div>
                <div className="th tcol-5 ">{pointsSectionLabels?.columnOneLabel ? pointsSectionLabels.columnOneLabel : 'Note'}</div>
                <div className="th tcol-2">{pointsSectionLabels?.columnTwoLabel ? pointsSectionLabels.columnTwoLabel : 'Point'}</div>
                {brandData.BrandID !== 87 && (
                  <div className="th tcol-2">{pointsSectionLabels?.columnThreeLabel ? pointsSectionLabels.columnThreeLabel : 'Sum'}</div>
                )}
                <div className="th tcol-3">{pointsSectionLabels?.columnFourLabel ? pointsSectionLabels.columnFourLabel : translate('_DATE_', 'Dato')}</div>
                {isWalletExpiryExpiryEnabled && (
                  <div className="th tcol-3">{translate('_POINT_EXPIRY_', 'Udløber')}</div>
                )}
              </div>
              <div className="table-body">
                {transactions.map((transaction, idx) => (
                  <div className="tr" key={idx}>
                    <div className="td tcol-xsmall"></div>
                    <div className="td tcol-5 ">{transaction.walletNote}</div>
                    <div className="td tcol-2">{priceConvertor(brandData,transaction.walletAmountPoints, ' ')}</div>
                    {brandData.BrandID !== 87 && (
                      <div className="td tcol-2">{priceConvertor(brandData,transaction.sum, ' ')}</div>
                    )}
                    <div className="td tcol-3">{transaction.date}</div>
                    {isWalletExpiryExpiryEnabled && (
                      <div className="td tcol-3">{transaction.expirationDate}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
      }
    </>
  )
}

export default TransactionTable;

export const SimpleTable = (props) => {
  const { headers, rows } = props
  // rows and headers follow this structure 
  // [{value: "", className: ""}, {value: "", className: ""} ...]

  return <>
    <div className="transaction-table">
      <div className="table-head">
        {
          headers.map((h, idx) => <div key={`${h}-${idx}`} className={h.className || "th tcol-2"}>{h.value || ""}</div>)
        }
      </div>
      <div className="table-body">
        {rows.map((r, idx) => (
          <div className="tr" key={`tr-${idx}`}>
            {r.map((item,i) => <div key={`tr-${idx}-${i}`}className={item.className || "td tcol-2"}>{item.value || ""}</div>)}            
          </div>
        ))}
      </div>
    </div>
  </>
}